export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125PV_0046_MR1_6214.41558b0c.jpg";